import styled from "styled-components";
import { SearcherItemButtonDesktop } from "../../../searcher/searcher-button/views/desktop/styled.js";
import { SearcherItem, SearcherMiddle } from "../../../searcher/styled.js";
export const SearcherMiddleWrapper = styled(SearcherMiddle).withConfig({
    displayName: "styled__SearcherMiddleWrapper",
    componentId: "sc-ac1dc40-0"
})`
	&.has-classes {
		${SearcherItem} {
			${({ theme  })=>theme.media.up('xl')} {
				flex-basis: calc(20% - var(--division-gap));
			}
		}

		${SearcherItemButtonDesktop} {
			${({ theme  })=>theme.media.up('xl')} {
				flex-basis: auto;
			}
		}
	}
`;

//# sourceMappingURL=styled.js.map